import type { BriefReferenceInput } from "../types";
import { referenceKey } from "../_shared";
import { fetchComposerSnapshot } from "../snapshot";

export const getOptionMapForWorkspace = async (workspaceId: string) => {
  const snapshot = await fetchComposerSnapshot(workspaceId);
  const { buildReferenceLookup } = await import("../_shared");
  return buildReferenceLookup(snapshot);
};

export const validateBriefReferenceInputs = async (
  workspaceId: string,
  references: BriefReferenceInput[],
) => {
  const optionMap = await getOptionMapForWorkspace(workspaceId);
  const validReferences: Array<BriefReferenceInput & { labelSnapshot: string }> = [];
  const seen = new Set<string>();

  for (const reference of references) {
    const key = referenceKey(reference.referenceType, reference.referenceId);
    if (seen.has(key)) continue;

    const option = optionMap.get(key);
    if (!option) {
      throw new Error("One or more selected references are no longer available in this workspace.");
    }

    validReferences.push({
      ...reference,
      labelSnapshot: reference.labelSnapshot?.trim() || option.label,
    });
    seen.add(key);
  }

  return validReferences;
};
